module.exports = __webpack_public_path__ + "img/255.0ff338a3.png";